import React from 'react';
import { EventForm } from 'Components/widgets/event-form/EventForm';
import { addTranslationKeys } from 'Src/i18n';
import type { EventResortProps } from 'Components/lines/event-form-line/EventFormLine.utils';
import {
  getEventFormResorts,
  getEventFormRegions,
} from 'Components/lines/event-form-line/EventFormLine.utils';
export type EventFormAffinityTranslationProps = {
  formTitle: string;
  formButton: string;
  formSuccess: EventFormResponseTranslations;
  formError: EventFormResponseTranslations;
  groupSection: {
    title: string;
    numberOfParticipantsLabel: string;
    numberOfParticipantsPlaceholder: string;
    commentLabel: string;
    commentPlaceholder: string;
    datesLabel: string;
    datesPlaceholder: string;
    datesFormat: string;
    flexibleDatesLabel: string;
    destinationLabel: string;
    destinationPlaceholder: string;
    resortLabel: string;
    resortPlaceholder: string;
  };
  userSection: {
    title: string;
    companyLabel: string;
    companyPlaceholder: string;
    firstNameLabel: string;
    firstNamePlaceholder: string;
    lastNameLabel: string;
    lastNamePlaceholder: string;
    emailLabel: string;
    emailPlaceholder: string;
    phoneLabel: string;
    phonePlaceholder: string;
    addressLabel: string;
    streetLabel: string;
    streetPlaceholder: string;
    postcodeLabel: string;
    postcodePlaceholder: string;
    cityLabel: string;
    cityPlaceholder: string;
    countryLabel: string;
    countryPlaceholder: string;
    personalInformationOptinLabel: string;
    displayAddressFields: boolean;
    clientTypeLabel: string;
    clientTypePlaceholder: string;
    clientTypeOptions: Array<{
      value: string;
      name: string;
    }>;
    optinLabel: string;
    emailOptinLabel: string;
    smsOptinLabel: string;
    phoneOptinLabel: string;
  };
};
type EventFormAffinityProps = EventFormAffinityTranslationProps & {
  resorts: Array<EventResortProps>;
};
export const EventFormAffinityLine = (props: EventFormAffinityProps) => {
  addTranslationKeys({
    eventForm: props,
  });
  const {
    formError,
    formSuccess,
    resorts,
    userSection: { displayAddressFields, clientTypeOptions },
  } = props;
  const formResorts = getEventFormResorts(resorts);
  const formRegions = getEventFormRegions(formResorts);
  return (
    <EventForm
      type="affinity"
      displayAddressFields={displayAddressFields}
      typeOptions={clientTypeOptions}
      formError={formError}
      formSuccess={formSuccess}
      regions={formRegions}
      resorts={formResorts}
      userSalutationOptions={[]}
    />
  );
};
